import React from 'react';
import type { EventProps } from 'react-big-calendar';
import type { CalendarComponentEvent } from '@axiom/validation';
import moment from 'moment-timezone';

import { CondensedSmall } from '../../content/CondensedSmall/CondensedSmall';
import { Flashy } from '../../element/Flashy/Flashy';

export type CalendarEventProps = Omit<EventProps, 'event'> & {
  event: CalendarComponentEvent;
};

const formatEventTime = (start: Date, end: Date): string => {
  const startStr = moment(start).format('h:mm');
  const endStr = moment(end).format('h:mm');
  return `${startStr} - ${endStr}`;
};

export const CalendarEvent = ({ event }: CalendarEventProps) => {
  // Settled interviews show their title (e.g., "Interview with Jane Doe").
  // Drafts (state !== 'saved') and free-time blocks (busy === false) show
  // the time range instead — drafts use it as live drag feedback, and
  // free-time blocks have no meaningful title to display.
  const isSettledInterview = event.state === 'saved' && event.busy;
  const displayText = isSettledInterview
    ? event.title
    : formatEventTime(event.start, event.end);

  return (
    <div
      data-test={event.name ?? 'EVENT'}
      data-value={`${event.start.toISOString()}~${event.end.toISOString()}`}
    >
      <CondensedSmall name="EVENT_HEADER">
        {event.error ? (
          <Flashy name="ERROR_FLASHY" color="textAlert">
            {event.error}
          </Flashy>
        ) : (
          displayText
        )}
      </CondensedSmall>
    </div>
  );
};
